module.exports = __webpack_public_path__ + "static/media/img2-3.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/nutricheck_foliar/K/img2-3.png
// module id = 1123
// module chunks = 3